import {
  energyType,
  unitOfMeasurement,
} from '@integration/api-client/tariffmanagement';

enum DynamicTariffGroupTypes {
  MARKET_PRICE = 'MARKET_PRICE',
  PURCHASING_FEE = 'PURCHASING_FEE',
  TAX = 'TAX',
}

export {
  energyType as EnergyType,
  unitOfMeasurement as UnitOfMeasurement,
  DynamicTariffGroupTypes,
};
